import angular from 'angular'
import './permissions.service'
import './users.service'
import './details/details.controller'

angular
  .module('admin.users', ['users.service', 'admin.users.details', 'admin.permissions.service'])
  .controller('UserAdminCtrl', UserAdminCtrl)

/** @ngInject */
function UserAdminCtrl(
  $scope,
  $rootScope,
  $stateParams,
  $state,
  $timeout,
  UsersService,
  UserCache,
  PermissionService,
  UploadService,
  PublisherAdminService,
  MarketplaceService,
) {
  var vm = this
  $rootScope.page = 'page'
  vm.items = []
  vm.create = false
  vm.pathImgT = ''
  vm.model = {}
  vm.sortType = ''
  vm.sortReverse = false
  vm.listPermission = [
    { id: 1, t: 'Full Access' },
    { id: 2, t: 'Customer Service' },
  ]
  vm.publisherTypes = [
    { id: 1, t: 'Full Access' },
    { id: 2, t: 'Per Channel' },
  ]
  vm.publisherType = null
  vm.marketplace = null
  PublisherAdminService.listAll().then(function (result) {
    vm.publishers = result.results
  })

  MarketplaceService.list(0, 100).then(function (result) {
    vm.marketplaces = result.results
  })

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.usersPerPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  vm.durs = [
    {
      t: 'Forever',
      val: '',
    },
    {
      t: '1 hour',
      val: '1h',
    },
    {
      t: '4 hour',
      val: '4h',
    },
    {
      t: '8 hour',
      val: '8h',
    },
    {
      t: '24 hour',
      val: '24h',
    },
    {
      t: '3 days',
      val: '72h',
    },
    {
      t: '1 week',
      val: '168h',
    },
    {
      t: '2 weeks',
      val: '336h',
    },
  ]

  vm.reasons = [
    {
      t: 'Bullying',
      val: 'Bullying',
    },
    {
      t: 'Cursing',
      val: 'Cursing',
    },
    {
      t: 'Bad username',
      val: 'Bad username',
    },
    {
      t: 'Bad user photo',
      val: 'Bad user photo',
    },
    {
      t: 'Soliciting',
      val: 'Soliciting',
    },
    {
      t: 'Fraud',
      val: 'Fraud',
    },
    {
      t: 'Other',
      val: 'Other',
    },
  ]

  vm.options = [
    {
      id: 0,
      name: 'ID',
    },
    {
      id: 1,
      name: 'Username',
    },
    {
      id: 2,
      name: 'Email',
    },
    {
      id: 3,
      name: 'Username Changes',
    },
    {
      id: 4,
      name: 'Email Changes',
    },
    {
      id: 5,
      name: 'Phone',
    },
  ]

  vm.option = vm.options[1].id

  var search = localStorage.getItem('search')
  if (search !== null) {
    vm.search = search
  }
  load(1)

  $scope.$watch('vm.search', function (newVal) {
    if (newVal === '' || newVal === null || newVal === undefined) {
      localStorage.removeItem('search')
    }
  })

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    vm.items = []

    if (vm.search === undefined || vm.search === null || vm.search === '' || vm.search.length < 1) {
      localStorage.removeItem('search')
      UsersService.getAll(vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        vm.items = result.results
      })
      return
    }

    if (vm.option === 0) {
      UsersService.get(vm.search).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        vm.items = [result.results]
      })
    } else if (vm.option === 1) {
      UsersService.search(vm.search, '', vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        localStorage.setItem('search', vm.search)

        vm.items = result.results
      })
    } else if (vm.option === 2) {
      UsersService.searchEmail(vm.search, '', vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        localStorage.setItem('search', vm.search)

        vm.items = result.results
      })
    } else if (vm.option === 3) {
      UsersService.searchUsernameChange(vm.search, '', vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        localStorage.setItem('search', vm.search)

        vm.items = result.results
      })
    } else if (vm.option === 4) {
      UsersService.searchEmailChange(vm.search, '', vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        localStorage.setItem('search', vm.search)

        vm.items = result.results
      })
    } else {
      UsersService.searchPhone(vm.search, '', vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        localStorage.setItem('search', vm.search)

        vm.items = result.results
      })
    }
  }

  vm.pageChanged = function (newPage) {
    load(newPage)
  }

  vm.sort = function (type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }

    load(vm.pagination.current)
  }

  vm.add = function () {
    $('#callModal').click()
    $timeout(function () {
      $('#username').focus()
    }, 500)
  }

  vm.edit = function (item) {
    item.editing = !item.editing
  }

  vm.save = function (item) {
    vm.create = false
    if (item.id !== undefined && item.id !== '' && item.id !== 0) {
      UsersService.update(item.id, item).then(function () {
        $('#callModal').click()
        swal('Created with success!', '', 'success')
        reloadPagination()
        load(1)
      })
    } else {
      UsersService.signup(item).then(function () {
        $('#callModal').click()
        swal('Created with success!', '', 'success')
        reloadPagination()
        load(1)
      })
    }
  }

  vm.cancel = function (item) {
    if (item.id === 0) {
      vm.items.remove(item)
    }
    vm.create = false
    item.editing = !item.editing
  }

  vm.addCoins = function (item) {
    swal(
      {
        title: 'Adding Coins',
        text: 'Amount of coins',
        type: 'input',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: 'slide-from-top',
        inputPlaceholder: 'Coins',
        inputValue: 0,
      },
      function (inputValue) {
        if (inputValue === false) {
          return false
        }
        if (inputValue === '') {
          swal.showInputError('You need to write something!')
          return false
        }
        if (isNaN(parseInt(inputValue))) {
          swal.showInputError('You need to write numbers!')
          return false
        }
        if (item.id === undefined) {
          swal(
            'Sorry an error ocurred.',
            'Contact with channel QP2 and send url that happens error. Thank you!',
            'warning',
          )
          return
        }
        UsersService.addCoins(item.id, { coins: parseInt(inputValue) }).then(
          function () {
            item.c = item.c + parseInt(inputValue)
            reloadPagination()
            load(1)
            swal.close()
          },
          function (err) {
            var e = err.error.message.split(';')
            var html = ''
            for (var i = 0; i < e.length; i++) {
              html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
            }
            swal({
              title: 'Adding Coins',
              text: html,
              html: true,
            })
          },
        )
      },
    )
  }

  vm.addCashs = function (item) {
    swal(
      {
        title: 'Adding Cash',
        text: 'Amount of cash',
        type: 'input',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: 'slide-from-top',
        inputPlaceholder: 'Cash',
        inputValue: 0,
      },
      function (inputValue) {
        if (inputValue === false) {
          return false
        }
        if (inputValue === '') {
          swal.showInputError('You need to write something!')
          return false
        }
        if (isNaN(parseFloat(inputValue))) {
          swal.showInputError('You need to write numbers!')
          return false
        }
        if (item.id === undefined) {
          swal(
            'Sorry an error ocurred.',
            'Contact with channel QP2 and send url that happens error. Thank you!',
            'warning',
          )
          return
        }

        UsersService.addCash(item.id, { coins: parseInt(inputValue) }).then(
          function () {
            item.c = item.c + parseInt(inputValue)
            reloadPagination()
            load(1)
            swal.close()
          },
          function (err) {
            var e = err.error.message.split(';')
            var html = ''
            for (var i = 0; i < e.length; i++) {
              html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
            }
            swal({
              title: 'Adding Cash',
              text: html,
              html: true,
            })
          },
        )
      },
    )
  }

  vm.uploadT = function (item) {
    item.loadT = true
    vm.loadT = true
    UploadService.save('users', vm.pathImgT, 'img', item.id).then(function (fileName) {
      item.loadT = false
      vm.loadT = false
      item.img = fileName
      vm.model.img = fileName
      UsersService.update(item.id, item).then(function () {
        reloadPagination()
        load(1)
      })
    })
  }

  vm.uploadT2 = function () {
    vm.loadT = true
    UploadService.save('users', vm.pathImgT, 'img', vm.model.id).then(function (fileName) {
      vm.loadT = false
      vm.model.img = fileName
      UsersService.update(vm.model.id, vm.model).then(function () {
        reloadPagination()
        load()
      })
    })
  }

  vm.report = function (item) {
    UsersService.report(item.id).then(function () {
      reloadPagination()
      load(1)
    })
  }

  vm.unreport = function (item) {
    UsersService.clearReport(item.id).then(function () {
      reloadPagination()
      load(1)
    })
  }

  vm.block = function (item) {
    vm.id = item.id
    vm.username = item.username
    $('#myModal').modal('show')
  }

  vm.saveModal = function () {
    var reason = vm.reason

    if (reason === '' || reason === null || reason === undefined) {
      swal('Suspension Incomplete: Please add a reason', '', 'error')
      return
    }

    if (vm.reason === 'Other') {
      var isPass = true
      if (vm.txt === null || vm.txt === undefined || vm.txt === '') {
        isPass = false
      } else {
        isPass = true
      }

      if (!isPass) {
        if (vm.reason2 === null || vm.reason2 === undefined || vm.reason2 === '') {
          isPass = false
        } else {
          isPass = true
        }
      }

      if (!isPass) {
        swal('Suspension Incomplete: Please add a Reason/Description', '', 'error')
        return
      }
    }

    if (vm.reason2 !== null && vm.reason2 !== undefined && vm.reason2 !== '') {
      reason = vm.reason2
    }

    var model = {
      txt: vm.txt,
      dur: vm.dur,
      reason: reason,
    }

    if (model.dur === '' || model.dur === null || model.dur === undefined) {
      delete model.dur
    }
    UsersService.block(vm.id, model).then(function () {
      var cache = UserCache.getObject()
      var userId = cache.user.id
      if (vm.changeUsername) {
        var username = 'Guest_' + vm.id
        UsersService.changeUsername(vm.id, { username: username }).then(function () {
          var model = {
            'id-u': parseInt(vm.id),
            'id-a': parseInt(userId),
            txt:
              'Reason: ' +
              reason +
              ' | Old username: ' +
              vm.username +
              ' | New username: ' +
              username +
              ' | Date: ' +
              new Date().toISOString().split('T')[0] +
              ' | Admin: ' +
              cache.user.username,
          }

          UsersService.createNotes(vm.id, model).then(function () {
            $('#myModal').modal('hide')
            swal('Suspended!', 'The name been changed and note created', 'success')
            reloadPagination()
            load(vm.pagination.current)
          })
        })
      } else {
        var model = {
          'id-u': parseInt(vm.id),
          'id-a': parseInt(userId),
          txt:
            'Reason: ' +
            reason +
            ' | Username: ' +
            vm.username +
            ' | Date: ' +
            new Date().toISOString().split('T')[0] +
            ' | Admin: ' +
            cache.user.username,
        }

        UsersService.createNotes(vm.id, model).then(function () {
          $('#myModal').modal('hide')
          swal('Suspended!', 'The name been changed and note created', 'success')
          reloadPagination()
          load(vm.pagination.current)
        })
      }
    })
  }

  vm.unblock = function (item) {
    UsersService.unblock(item.id).then(function () {
      swal('Unsuspension', '', 'success')
      reloadPagination()
      load(1)
    })
  }

  vm.searchUsers = function () {
    reloadPagination()
    load(1)
  }

  vm.producer = function (item) {
    if (item.producer) {
      swal(
        {
          title: 'Permissions',
          text: 'You want to remove this permission?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: false,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            PermissionService.deleteProducer(item.producer.id).then(function () {
              swal(
                'Deleted!',
                'Your permission has been deleted.\n Permission: Producer',
                'success',
              )
              item.producer = !item.producer
              load(vm.pagination.current)
            })
          }
        },
      )
    } else {
      vm.userId = item.id
      vm.useItem = item
      $('#myModal1').modal('show')
    }
  }

  vm.selectPublisher = function () {
    $('#myModal1').modal('hide')
    swal(
      {
        title: 'Permissions',
        text: 'You want to add this permission?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          var model = {
            'id-u': vm.userId,
            'id-pu': vm.publisherId,
            k: vm.publisherType,
          }
          if (vm.marketplace) {
            model['id-mp'] = vm.marketplace
          }
          PermissionService.addProducer(model).then(function () {
            swal(
              'Created!',
              'Your permission has been created. \n Permission: Publisher',
              'success',
            )
            vm.useItem.producer = !vm.useItem.producer
            vm.publisherId = null
            load(vm.pagination.current)
          })
        }
      },
    )
  }

  vm.removeAdministrator = function () {
    if (vm.bkpAdmin.admin) {
      swal(
        {
          title: 'Permissions',
          text: 'You want to remove this permission?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: false,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            PermissionService.deleteAdministrator(vm.bkpAdmin.admin.id).then(function () {
              swal(
                'Deleted!',
                'Your permission has been deleted. \n Permission: Administrator',
                'success',
              )
              $('#myModal2').modal('hide')
              load(vm.pagination.current)
            })
          }
        },
      )
    } else {
      swal('This user not is admin', '', 'warning')
    }
  }

  vm.administrator = function () {
    if (vm.permissionType === null || vm.permissionType === undefined || vm.permissionType === '') {
      swal('Must Choose Admin Type', '', 'warning')
      return
    }

    swal(
      {
        title: 'Permissions',
        text: 'You want to add this permission?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: false,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          var model = {
            k: parseInt(vm.permissionType),
            'id-u': vm.bkpAdmin.id,
          }
          if (vm.marketplace) {
            model['id-mp'] = vm.marketplace
          }

          if (vm.bkpAdmin.admin) {
            PermissionService.updateAdministrator(vm.bkpAdmin.admin.id, model).then(
              function (result) {
                swal(
                  'Updated!',
                  'Your permission has been updated. \n Permission: Administrator',
                  'success',
                )
                $('#myModal2').modal('hide')
                var auth = UserCache.getObject()
                if (vm.bkpAdmin.id === auth.user.id) {
                  $rootScope.logout()
                } else {
                  load(vm.pagination.current)
                }
              },
            )
          } else {
            PermissionService.addAdministrator(model).then(function (result) {
              swal(
                'Created!',
                'Your permission has been created. \n Permission: Administrator',
                'success',
              )
              $('#myModal2').modal('hide')
              load(vm.pagination.current)
            })
          }
        }
      },
    )
  }

  vm.modalAdmin = function (item) {
    vm.bkpAdmin = item
    if (vm.bkpAdmin.admin) {
      vm.permissionType = vm.listPermission[vm.bkpAdmin.admin.k - 1].id
      vm.marketplace = vm.marketplaces.find((m) => m.id === vm.bkpAdmin.admin['id-mp']).id
    } else {
      vm.permissionType = null
    }
    $('#myModal2').modal('show')
  }

  vm.roles = function (item) {
    $state.go('admin.users.details.roles', { parentId: item.id })
  }

  vm.moderator = function (item) {
    if (item.mod) {
      swal(
        {
          title: 'Permissions',
          text: 'You want to remove this permission?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: false,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            PermissionService.deleteModerator(item.id).then(function () {
              swal(
                'Deleted!',
                'Your permission has been deleted. \n Permission: Moderator',
                'success',
              )
              item.mod = !item.mod
              load(vm.pagination.current)
            })
          }
        },
      )
    } else {
      swal(
        {
          title: 'Permissions',
          text: 'You want to add this permission?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: false,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            PermissionService.addModerator(item.id).then(function () {
              swal(
                'Created!',
                'Your permission has been created. \n Permission: Moderator',
                'success',
              )
              item.mod = !item.mod
              vm.publisherId = null
              load(vm.pagination.current)
            })
          }
        },
      )
    }
  }
}
